import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
	const [isMobile, setIsMobile] = React.useState<boolean>(false)

	React.useEffect(() => {
		const detectMobile = () => {
			const ua = navigator.userAgent.toLowerCase()
			const small = window.innerWidth < MOBILE_BREAKPOINT
			const touch =
				"ontouchstart" in window || navigator.maxTouchPoints > 0

			return (
				(ua.includes("android") ||
					ua.includes("mobile") ||
					ua.includes("iphone") ||
					ua.includes("ipad") ||
					ua.includes("ipod")) &&
				small &&
				touch
			)
		}

		const onChange = () => {
			setIsMobile(detectMobile())
		}

		const mql = window.matchMedia(
			`(max-width: ${MOBILE_BREAKPOINT - 1}px)`
		)

		mql.addEventListener("change", onChange)
		window.addEventListener("resize", onChange)

		// initial evaluation
		setIsMobile(detectMobile())

		return () => {
			mql.removeEventListener("change", onChange)
			window.removeEventListener("resize", onChange)
		}
	}, [])

	return isMobile
}
